import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import { LightEllipse, WaveInside, LineDot } from 'src/assets';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './strategy.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const Strategy = () => {
  const { t } = useTranslation();

  const [activeIndex, setActiveIndex] = useState();

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  const [isFullscreen, setIsFullScreen] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resize = () => {
      setWindowWidth(window.innerWidth);

      if (window.innerWidth <= 740) {
        setIsFullScreen(false);
      }
    };

    window.addEventListener('resize', resize);
  }, []);

  const onClickItem = useCallback(() => {
    if (windowWidth > 740) {
      setIsFullScreen(true);
    }
  }, [windowWidth]);

  const isMobile = windowWidth <= 768;

  const slidesPerView = isMobile ? 1 : 2;

  return (
    <>
      <div className="strategy-wave-wrapper">
        <div className="strategy-wave">
          <div className={`strategy-wave-content`} ref={ref}>
            <img src={WaveInside} alt={WaveInside} />
          </div>
        </div>
      </div>
      <div className="strategy">
        <div className={`strategy-content  ${isVisible ? 'active-animation' : ''}`}>
          <div className="strategy-title">
            <div>
              <supertitle>{t('strategy:supertitle')}</supertitle>
              <h1 className="strategy-heading">
                <black-underline>{t('strategy:strategy')}</black-underline>{' '}
                {t('strategy:forTrading')}
              </h1>
              <text>{t('strategy:subtitle')}</text>
            </div>
            <img src={LineDot} alt={LineDot} />
          </div>
          <div className="strategy-section">
            <Swiper
              navigation={true}
              modules={[Navigation, Pagination]}
              pagination={{ clickable: true }}
              spaceBetween={20}
              style={
                {
                  // height: activeIndex === 4 && !isMobile ? 'auto' : isMobile ? '750px' : 'auto',
                }
              }
              slidesPerView={slidesPerView}
              onSlideChange={handleSlideChange}
            >
              <SwiperSlide>
                <div className="strategy-slide-content">
                  <div className="strategy-slide-item">
                    <h3>
                      {t('strategy:daily')} <blue-text>{t('strategy:market')}</blue-text>
                    </h3>
                    <div className="strategy-slide-item-divider" />
                    <text>
                      <Trans i18nKey="strategy:dailySub" />
                    </text>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="strategy-slide-content">
                  <div className="strategy-slide-item">
                    <h3>
                      {t('strategy:tech')} <blue-text>{t('strategy:analysis')}</blue-text>
                    </h3>
                    <div className="strategy-slide-item-divider" />
                    <text>
                      <Trans i18nKey="strategy:techSub" />
                    </text>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="strategy-slide-content">
                  <div className="strategy-slide-item">
                    <h3>{t('strategy:scalp')}</h3>
                    <div className="strategy-slide-item-divider" />
                    <text>
                      <Trans i18nKey="strategy:scalpSub" />
                    </text>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="strategy-slide-content">
                  <div className="strategy-slide-item">
                    <h3>
                      {t('strategy:swing')} <blue-text>{t('strategy:trade')}</blue-text>
                    </h3>
                    <div className="strategy-slide-item-divider" />
                    <text>
                      <Trans i18nKey="strategy:swingSub" />
                    </text>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="strategy-slide-content">
                  <div className="strategy-slide-item">
                    <h3>
                      {t('strategy:position')} <blue-text>{t('strategy:posTrade')}</blue-text>
                    </h3>
                    <div className="strategy-slide-item-divider" />
                    <text>
                      <Trans i18nKey="strategy:posSub" />
                    </text>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="strategy-slide-content">
                  <div className="strategy-slide-item">
                    <h3>
                      {t('strategy:fund')} <blue-text>{t('strategy:fundAnalysis')}</blue-text>
                    </h3>
                    <div className="strategy-slide-item-divider" />
                    <text>
                      <Trans i18nKey="strategy:hundSub" />
                    </text>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          <img src={LightEllipse} alt={LightEllipse} className="strategy-image-1" />
          <img src={LightEllipse} alt={LightEllipse} className="strategy-image-2" />
          <img src={LightEllipse} alt={LightEllipse} className="strategy-image-3" />
        </div>
      </div>
    </>
  );
};
